import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { IEvaluateInternalAssessmentDialog } from "./EvaluateInternalAssessmentDialog";

import { EvaluationStatusSaveModel } from "../../common/components/questionnaireComponents/evaluateQuestionnaireDialog/EvaluateQuestionnaireDialog.types";
import { put } from "../../common/api/apiShared";
import { createElement } from "react";
import { Trans } from "react-i18next";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export default function useEvaluateInternalAssessmentDialogHooks(props: IEvaluateInternalAssessmentDialog) {
    const snackbar = useDotLegalSnackbar();

    const evaluationMutation = useDotLegalMutation(evaluateApi);

    const saveEvaluation = (saveModel: EvaluationStatusSaveModel) => {
        evaluationMutation.mutateAsync(saveModel, {
            onSuccess: (resp: any) => {
                props.onEvaluated();
                snackbar.show(createElement(Trans, { i18nKey: "auditEvaluated", values: { name: props.selectedInternalAssessment.questionnaireName } }));
            },
        });
    };

    function evaluateApi(saveModel: EvaluationStatusSaveModel) {
        return put<{}>(`/internalAssessments/${props.selectedInternalAssessment.id}/evaluate`, saveModel);
    }

    return {
        saveEvaluation,
        isSaving: evaluationMutation.isLoading,
    };
}
